import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useMainBannerLogic } from './MainBannerLogic';
import BasicMainBannerSkin from './skins/BasicMainBannerSkin';

/**
 * MainBanner 컴포넌트의 스킨 시스템 정의
 */
export const MainBannerSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.MAIN_BANNER,
  name: '메인 배너',
  category: 'content',
  icon: '🎨',
  supportsExternalSkins: true,
  options: [
    {
      type: 'select',
      label: '배너 모드',
      key: 'mode',
      options: [
        { value: 'slider', label: '슬라이더' },
        { value: 'carousel', label: '캐러셀' },
        { value: 'fade', label: '페이드' }
      ],
      default: 'slider'
    },
    {
      type: 'checkbox',
      label: '자동 재생',
      key: 'autoPlay',
      default: true
    },
    {
      type: 'number',
      label: '자동 재생 속도 (ms)',
      key: 'autoPlaySpeed',
      default: 5000,
      min: 1000,
      max: 10000
    },
    {
      type: 'number',
      label: '전환 속도 (ms)',
      key: 'transitionSpeed',
      default: 500,
      min: 100,
      max: 2000
    },
    {
      type: 'checkbox',
      label: '점 표시',
      key: 'showDots',
      default: true
    },
    {
      type: 'checkbox',
      label: '화살표 표시',
      key: 'showArrows',
      default: true
    },
    {
      type: 'checkbox',
      label: '호버 시 일시정지',
      key: 'pauseOnHover',
      default: true
    },
    {
      type: 'checkbox',
      label: '무한 루프',
      key: 'infiniteLoop',
      default: true
    },
    {
      type: 'text',
      label: '데스크톱 높이',
      key: 'desktopHeight',
      default: '600px'
    },
    {
      type: 'text',
      label: '모바일 높이',
      key: 'mobileHeight',
      default: '400px'
    }
    // TODO: array 타입 지원 필요
    // {
    //   type: 'array',
    //   label: '배너 아이템',
    //   key: 'banners',
    //   itemOptions: [...],
    //   default: [...]
    // }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicMainBannerSkin
  },
  useLogic: useMainBannerLogic,
  defaultProps: {
    componentProps: {
      mode: 'slider',
      banners: [
        {
          text: '환영합니다!',
          description: '메인 배너에 오신 것을 환영합니다.',
          url: '#',
          icon: 'https://via.placeholder.com/1600x700',
          mediaType: 'image',
          position: '5',
          textColor: 'white',
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.6)',
          buttonBgColor: '#ff6b6b',
          buttonTextColor: 'white',
          buttonHoverColor: '#ff5252',
          buttonText: '자세히 보기',
          showTitle: true,
          showButton: true
        }
      ],
      autoPlay: true,
      autoPlaySpeed: 5000,
      transitionSpeed: 500,
      showDots: true,
      showArrows: true,
      pauseOnHover: true,
      infiniteLoop: true,
      desktopHeight: '600px',
      mobileHeight: '400px'
    },
    style: {
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    }
  }
};